import { useMutation, useQueryClient } from '@tanstack/react-query';
import { codeApi } from '../api/codeApi';
import type { CommonCodeValueRequest } from '../types/code';

/**
 * POST /api/eraf/codes/groups/{groupCode}/items — 코드 항목 생성
 * 성공 시 ['common-code', 'items', groupCode] 쿼리 무효화
 */
export function useCreateCodeItem() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ groupCode, body }: { groupCode: string; body: CommonCodeValueRequest }) =>
      codeApi.createItem(groupCode, body),
    onSuccess: (_data, variables) => {
      void queryClient.invalidateQueries({
        queryKey: ['common-code', 'items', variables.groupCode],
      });
      // 항목 수 갱신을 위해 그룹 목록도 무효화
      void queryClient.invalidateQueries({ queryKey: ['common-code', 'list'] });
    },
  });
}
